export default "__VITE_ASSET__TZOjf5QI__"